// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { useSelector } from 'react-redux'
import DropDown from '../DropDown'
import Menu from './Menu'

import Ellipsis from './Ellipsis'

const User = () => {
  const userName = useSelector(state => state.user.get('userName'))

  return (
    <div className={'header-user-info display-flex align-items-center'}>
      <p id={'header-user-username'}>
        {userName}
      </p>
      <DropDown
        idRoot={'header-user-menu'}
        Header={<Ellipsis />}
        Menu={Menu} />
    </div>
  )
}

export default User
